import type {
  CustomLandingPage,
  LandingPageBody,
  LandingPageParams,
} from "@apptus/esales-api";
import elevateClient from "@server/elevate";

import type { MarketConfiguration } from "@/config/markets/const";

import mapCustomAttributes from "./mapCustomAttributes";

export default async function getRawLandingPage(
  market: MarketConfiguration,
  input: LandingPageParams,
  config?: LandingPageBody,
): Promise<CustomLandingPage | undefined> {
  const { presentCustom = [], ...props } = input;
  return elevateClient(market).query.landingPage(
    {
      viewId: "production",
      notify:
        process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" &&
        typeof window !== "undefined",
      limit: 60,
      skip: 0,
      presentCustom: mapCustomAttributes(presentCustom, market),
      presentPrices: [
        `NG_${market.code.toLowerCase()}_best`,
        `NG_${market.code.toLowerCase()}_RRP`,
        `NG_${market.code.toLowerCase()}_pricematch`,
        `NG_${market.code.toLowerCase()}_campaign`,
      ],
      priceId: `NG_${market.code.toLowerCase()}_best`,
      ...props,
    },
    {
      navigation: {
        include: true,
      },
      recommendationLists: [{ id: "recs", algorithm: "TOP_PRODUCTS" }],
      primaryList: {
        include: true,
      },
      ...config,
    },
  );
}
